import type {AddComponentTypeOptions} from 'grapesjs';
import {SUBMIT_BUTTON_CONTAINER_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_SUBMIT_BUTTON_CONTAINER_TYPE = 'postermywall-submit-button-container';
const SUBMIT_BUTTON_CONTAINER_CLASS = 'postermywall-submit-button-container';

export const POSTERMYWALL_SUBMIT_BUTTON_CONTAINER: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    const classes = (el.getAttribute('class') ?? '').split(/\s+/);
    if (el.tagName === 'DIV' && classes.includes(SUBMIT_BUTTON_CONTAINER_CLASS)) {
      return {type: POSTERMYWALL_SUBMIT_BUTTON_CONTAINER_TYPE};
    }
    return undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      editable: false,
      removable: false,
      attributes: {
        class: SUBMIT_BUTTON_CONTAINER_CLASS,
        'data-pmw-type': POSTERMYWALL_SUBMIT_BUTTON_CONTAINER_TYPE,
      },
      style: SUBMIT_BUTTON_CONTAINER_STYLES,
    },
  },
};
